<template>
    <div class="tw-p-4" style="width: 100%; height: 100%; overflow: auto;">
        <!--
        <b-loading :is-full-page="true" v-model="loading" :can-cancel="false"></b-loading>
        -->
        <div class="">
            <div class="tw-grid tw-grid-cols-2 tw-grid-flow-row tw-p-3">
                <div class="tw-flex tw-flex-col">
                    <div class="tw-text-grey" style="font-size: 0.7em;"> CAMPAIGN &nbsp&nbsp
                        <a
                            @click="$router.push({name: 'EditCampaign', params: { campaign_id: campaign.campaign_id }})"
                            class="tw-cursor-pointer hover:tw-text-blue-900">EDIT</a></div>
                    <div class="tw-text-3xl tw-flex tw-items-center" style="line-height: 1.1em;">
                        {{campaign.name}}
                    </div>
                    <div class="tw-flex-1">
                        {{campaign.description}}
                    </div>
                    <div class="tw-mt-2">
                        <span class="tw-bg-gray-100 tw-rounded tw-px-3 tw-py-1 tw-mr-1" v-for="tag in campaign.tags">{{tag}}</span>
                    </div>
                </div>
                <div class="tw-grow-0 tw-shrink-0 tw-basis-auto tw-ml-auto">
                    <div class="tw-mt-1 tw-flex tw-flex-col">
                        <div v-for="i in history" class="tw-mb-2">
                            <div style="font-size: 0.8em;" :title="tooltip(i.new_updated_on)">
                                <div class="" >
                                    Updated {{dayjs(i.new_updated_on) }} by <a target="_blank" class="tw-text-blue-500 hover:tw-text-blue-600" :href="'https://admin.roonlabs.net/users/' + i.new_updated_by"> {{i.user.firstname + ' ' + i.user.lastname}}</a>
                                </div>
                                <div class="tw-text-grey tw-pl-5 tw-text-xs" v-for="d in diff(i)">
                                    {{d}}
                                </div>
                            </div>
                        </div>
                        <div>
                            <a v-if="history.length && !showAllHistory" @click="showAllHistory = true" class="tw-px-6">
                                <span
                                    class="tw-cursor-pointer mdi mdi-dots-horizontal">
                                </span>
                            </a>
                        </div>
                        <div>
                            <div class="tw-mt-2" style="padding-bottom: 1px; font-size: 0.8em;" :title="tooltip((campaign.created_on))">
                                Created {{dayjs((campaign.created_on))}} by <a target="_blank" class="tw-text-blue-500 hover:tw-text-blue-600" :href="'https://admin.roonlabs.net/users/' + campaign.created_by"> {{campaign.user.firstname + ' ' + campaign.user.lastname}}</a>
                            </div>
                        </div>
                        <div>
                            <button v-if="showAllHistory" @click="showAllHistory = !showAllHistory" class="">
                                <span class="tw-underline tw-text-blue-500 hover:tw-text-blue-900 tw-text-sm">
                                    Collapse
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-grid-flow-row">
                    <div class="tw-col-span-1 md:tw-col-span-4 tw-p-3" v-for="comm in (campaign.comms || []).sort((a, b) => a.name.localeCompare(b.name))">
                        <div
                            @click="openCommDetails(comm)"
                            class="tw-p-4 tw-bg-gray-100 tw-rounded tw-flex tw-flex-col"
                            style="height: 100%; min-height: 200px;">
                            <div class="tw-flex tw-items-center tw-justify-between">
                                <div class="tw-flex tw-items-center">
                                    <span
                                        :title="comm.comm_type"
                                        v-if="comm.comm_type === 'email'"
                                        class="mdi mdi-email"
                                    ></span>
                                    <span
                                        :title="comm.comm_type"
                                        v-else-if="comm.comm_type === 'in-app'"
                                        class="mdi mdi-inbox-full"
                                    ></span>
                                    <div class="tw-ml-1">
                                        {{comm.name}}
                                    </div>
                                </div>
                                <div class="tw-flex tw-gap-2">
                                    <a
                                        v-if="comm.comm_type === 'email'"
                                        target="_blank"
                                        :href="viewInBrowser(comm)"
                                        title="View in browser"
                                        class="hover:tw-text-gray-700 tw-cursor-pointer mdi mdi-link-variant"></a>
                                    <span 
                                        @click="copyCommId(comm)"
                                        title="Copy comm Id"
                                        class="hover:tw-text-gray-700 tw-cursor-pointer mdi mdi-content-copy"></span>
                                    <span
                                        title="View analytics"
                                        @click="getCommAnalytics(comm)"
                                        class="tw-cursor-pointer mdi mdi-chart-areaspline"
                                        size="is-small">
                                    </span>
                                    <span
                                        title="Edit comm"
                                        @click="$router.push({name:'EditComm', params: {campaign_id, comm_id: comm.comm_id}})"
                                        class="tw-cursor-pointer mdi mdi-pencil"
                                        size="is-small">
                                    </span>
                                    <span
                                        title="Delete comm"
                                        @click="deleteComm(comm)"
                                        class="tw-cursor-pointer mdi mdi-delete"
                                        size="is-small">
                                    </span>
                                </div>
                            </div>
                            <div class="tw-my-2">
                                <span class="tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-rounded" :class="comm.c" :style="comm.s" >{{ comm.t }}</span>
                                <span title="Send message at user's local time" 
                                    class="tw-rounded tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-rounded tw-ml-2 tw-bg-blue-600 tw-text-white" v-if="comm.time_in_local_time">
                                    <span class="mdi mdi-account tw-mr-1"></span>
                                    {{ comm.time_in_local_time_formatted }}
                                </span>
                            </div>
                            <div class="tw-flex">
                                <TField v-if="comm.sd" :title="tooltip(comm.start_date)" class="tw-text-xs tw-mr-2">
                                    {{comm.sd}}
                                </TField>
                                <TField v-if="comm.ed" :title="tooltip(comm.last_sent || comm.end_date)" class="tw-text-xs">
                                    {{comm.ed}}
                                </TField>
                            </div>
                            <div class="tw-py-3" style="font-size: 0.6em; flex: 1;">
                                <RulePreview :value="comm.filter ? comm.filter.rules[1] : null"></RulePreview>
                            </div>
                            <div v-if="comm.sp">
                                <TProgress
                                    :total="parseInt(comm.total_work)"
                                    :value="parseInt(comm.sent)"
                                >
                                </TProgress>
                            </div>
                            <!--
                            <progress v-if="comm.sp" class="progress m-0 mb-2 is-small" :value="comm.sent" :max="comm.total_work"></progress>
                            -->
                            <div class="tw-flex tw-justify-between">
                                <div class="tw-flex-1 tw-text-gray-500" v-if="comm.pt">
                                    {{comm.pt}}
                                </div>
                                <div class="tw-flex tw-items-center">
                                    <div
                                        style="line-height: 1.2em; font-size: 0.6em; white-space: pre; text-align: right;"
                                        class="tw-mr-2 tw-text-grey">{{niceCategory(comm.category)}}</div>
                                    <span
                                        :title="comm.send_type"
                                        v-if="comm.send_type === 'OneShot'"
                                        class="tw-text-gray-500 mdi mdi-numeric-1-box"
                                    ></span>
                                    <span
                                        :title="comm.send_type"
                                        v-else-if="comm.send_type === 'OnGoing'"
                                        class="tw-pl-1 tw-text-gray-500 mdi mdi-clock"
                                    ></span>
                                    <span
                                        :title="comm.send_type"
                                        v-else-if="comm.send_type === 'Event'"
                                        class="tw-text-gray-500 mdi mdi-gesture-double-tap"
                                    ></span>
                                    <span title="Send after this many hours/minutes" class="tw-text-gray-500 tw-text-xs tw-ml-2" v-if="comm.offset">
                                        +{{comm.offset_hours > 0 ? comm.offset_hours + 'hr' : ''}} {{comm.offset_minutes > 0 ? comm.offset_minutes + 'min' : ''}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tw-col-span-1 md:tw-col-span-4 tw-p-3">
                        <div
                            style="height: 100%; min-height: 200px;"
                            @click="$router.push({name: 'NewComm', params: { campaign_id: campaign.campaign_id }})" 
                            class="tw-p-4 tw-cursor-pointer hover:tw-bg-gray-200 tw-flex tw-items-center tw-justify-center tw-bg-gray-100 tw-rounded">
                            <span
                                class="tw-text-6xl mdi mdi-plus"
                            >
                            </span>
                        </div>
                       
                    </div>
                </div>
            </div>
        </div>
        <TModal v-model="deleteCommState.show">
            <div class="tw-px-2 tw-w-96">
                <span class="tw-text-2xl mdi mdi-alert-circle tw-text-red-600">&nbsp;<span class="tw-text-black">Deleting comm</span></span>
                <div class="tw-w-100 tw-break-normal tw-my-3 tw-mx-2">Are you sure you want to delete {{deleteCommState.comm?.name}}? All data will be permanently removed, and <b>cannot be recovered.</b></div>
                <div class="tw-mt-6 tw-flex tw-justify-end">
                    <TButton
                        class="tw-w-32 tw-mr-2 tw-text-white tw-bg-blue-600 hover:tw-bg-blue-500"
                        @click="deleteCommState.confirm"
                    >Yes</TButton>
                    <TButton
                        @click="deleteCommState.cancel"
                        class="tw-w-32 tw-bg-white tw-border tw-border-gray-500 tw-text-gray-900 hover:tw-border-gray-400 hover:tw-bg-white"
                    >No</TButton>
                </div>
            </div>
        </TModal>
        <TModal 
            width="tw-w-9/12 tw-absolute tw-top-1 tw-bottom-1"
            v-model="analytics.show">
            <div class="tw-w-full tw-h-full tw-flex tw-flex-col">
                <div class="tw-flex tw-justify-end">
                    <span
                        title="Refresh"
                        @click="getCommAnalytics(analytics.comm)"
                        class="mdi mdi-refresh mdi-24px tw-mr-2 tw-cursor-pointer"></span>
                    <span 
                        title="Close"
                        @click="closeCommAnalyticsModal"
                        class="mdi mdi-close mdi-24px tw-cursor-pointer"></span>
                </div>
                <iframe
                    :src="analytics.iframeUrl"
                    frameBorder="0"
                    class="tw-flex-1"
                    allowTransparency
                />
            </div>
        </TModal>
    </div>
</template>
<style lang="scss">
.preview-modal-2 {
    > .animation-content {
        max-height: none !important;
        min-height: 100% !important;
    }
}

</style>
<script>

import {
    TField,
    TProgress,
    TModal,
    TDropdown,
    TButton,
} from '@roonlabs/vue-tailwind';

import RulePreview              from '@/components/RulePreview.vue'
import TestSend                 from '@/components/TestSend.vue'
import { UndoHtmlReplaceLinks } from '@/core/links';
import Auth from '@/core/auth';
import axios from 'axios'

import { useToast }   from 'vue-toastification'

import dayjs          from 'dayjs';
import relativeTime   from 'dayjs/plugin/relativeTime';
import utc            from 'dayjs/plugin/utc';
import timezone       from 'dayjs/plugin/timezone'; // dependent on utc plugin
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(relativeTime)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(advancedFormat)

export default {
    components:{RulePreview,TestSend,TModal,TField,TProgress,TDropdown,TButton},
    props: {
        campaign_id: String
    },

    data() {
        return {
            campaign:       { user: {} },
            loading:        true,
            showAllHistory: false,
            showCommDetailsModal: false,
            showCommDetailsObj:   { content: { emails: [], message: {} } },
            previewSize:          'desktop',
            commDetailsMessage:  { body: {} },

            // Analytics
            analytics: {
                show:      false,
                iframeUrl: null,
                comm:      null
            },

            // Delete modal
            deleteCommState: {
                comm:    null,
                confirm: null,
                cancel:  null,
                loading: false,
                show:    false
            }
        }
    },
    methods: {
        viewInBrowser(comm) {
            return `https://commsbridge.roonlabs.net/api/1/comms/view-in-browser?comm_id=${comm.comm_id}&user_id=${Auth.state.userid}`
        },
        copyCommId(comm) {
            navigator.clipboard.writeText(comm.comm_id);
            this.toast.success(`Copied comm id to clipboard.`)
        },
        // Date helpers
        dayjs(dateobject) {
            return dayjs().to(dateobject);
        },

        tooltip(dateobject) {
            return dayjs(dateobject).format("dddd, MMMM D, YYYY h:mm A z")
        },

        scheduled(dateobject) {
            return dayjs().to(dateobject,true)
        },
        /////
        refreshPreview(html) {
            /*
            this.$nextTick(() => {
                $(this.$refs.iframe).contents().find('html').html(
                    UndoHtmlReplaceLinks( html || "")
                );
            })
             */
        },

        openCommDetails(comm) {
            this.showCommDetailsModal = true;
            this.showCommDetailsObj   = comm;

            if ( this.commDetailsMessages.length ) {
                this.setCommDetailsMessage(this.commDetailsMessages[0]);
            }
        },

        setCommDetailsMessage(message) {
            this.commDetailsMessage = message;
            if ( this.showCommDetailsObj.comm_type === 'email' ) {
                this.refreshPreview(message.body?.html);
            } else if ( this.showCommDetailsObj.comm_type === 'in-app' ) {
            }
        },

        async getCampaign() {
            this.loading = true;
            try {
                const res          = await axios.get(`/api/1/campaigns/${this.campaign_id}`)
                const { campaign } = res.data;
                const cleanComms   = [];
                (campaign.comms || [])
                .forEach(c => {
                    cleanComms.push(this.mapComm(c))
                })
                campaign.comms = cleanComms;
                this.campaign  = campaign;
            } catch (e) {
                console.log(e);
            }
            this.loading = false
        },
        // Utils
        diff(i) {
            const old = Object.keys(i).filter(i => i.startsWith('old_'));
            const diffs = []
            for ( let key of old ) {
                if ( key.includes('updated') ) continue;
                if ( JSON.stringify(i[key]) != JSON.stringify(i[key.replace('old_','new_')] )) {
                    diffs.push(`${key.replace('old_','')}: ${i[key]} => ${i[key.replace('old','new')]}`)
                }
            }
            return diffs
        },
        niceCategory(cat) {
            return cat.split('_').map(w => w[0].toUpperCase() + w.slice(1)).join('\n')
        },

        mapComm(comm) {
            const statusFields    = this.getStatusFields(comm);
            const offsetFields    = this.getOffsetFields(comm);
            const localTimeFields = this.getLocalTimeFields(comm);
            comm = {
                ...comm,
                ...statusFields,
                ...offsetFields,
                ...localTimeFields,
            }
            return comm
        },


        getStatusFields(comm) {
            let c  = {};
            let s  = {};
            let t  = '';
            let sd = '';
            let ed = '';
            let sp = false;
            let pt = '';
            if ( comm.enabled == false ) {
                c = { 'tw-bg-red-600': true, 'tw-text-white': true }
                t = 'Disabled';
                pt = `Sent ${comm.sent} messages`
            } else {
                if (comm.send_type == 'Event') {
                    c = { 'tw-bg-green-400': true, 'tw-text-white': true }
                    t = 'Enabled'
                    pt = '   '
                } else if ( comm.state == 'init' ) {
                    c = { 'tw-bg-yellow-200': true }
                    t = 'Computing'
                    pt = `Sent ${comm.sent} messages`
                } else if ( comm.state == 'reset' ) {
                    c = { 'tw-bg-yellow-200': true }
                    t = 'Recomputing'
                    pt = `Sent ${comm.sent} messages`
                } else if ( comm.state === 'ready' && (comm.start_date && new Date(comm.start_date).getTime() > Date.now() )) {
                    s  = { 'background-color': 'hsl(14, 100%, 53%)', 'color': 'white' }
                    t  = 'Scheduled'
                    pt = `Sent ${comm.sent} messages`
                    sd = `Scheduled to begin ${this.scheduled(comm.start_date)} from now`
                } else if ( comm.state == 'ready' ) {
                    c  = { 'tw-bg-green-400': true, 'tw-text-white': true }
                    t  = 'Active'
                    pt = `Sending messages (${comm.sent} / ${comm.total_work})`

                    if ( comm.send_type === 'OneShot' ) {
                        sp = true
                    }

                    // Stalled
                    if ( comm.send_type == 'OnGoing' && comm.sent == comm.total_work ) {
                        pt = `Sent ${comm.sent} messages, waiting for new users`
                    } else if (comm.next_to_send && new Date(comm.next_to_send) > Date.now()) {
                        // Stalled until later point
                        // Restart date will be equal to next_to_send, since that is where it is populated from
                        // so just use next_to_send instead
                        pt = `Sent ${comm.sent} of ${comm.total_work} messages, next email sends in ${this.scheduled(comm.next_to_send)}`
                    }
                    if ( comm.end_date && new Date(comm.end_date).getTime() > Date.now() ) {
                        ed = `Ending ${this.scheduled(comm.end_date)} from now`
                    }

                } else if ( comm.state == 'done' ) {
                    c = { 'tw-bg-slate-900': true , 'tw-text-white': true }
                    t = 'Completed'
                    sp = false
                    pt = `Sent ${comm.sent} messages`
                    ed = comm.last_sent ? `Completed ${this.scheduled(comm.last_sent)} ago` : ''
                }
            }
            // c = class, s = style, t = state, sd = start date, ed = end date, sp = show progress, pt = progess text
            return { c,s,t,sd,ed,sp,pt }
        },

        getOffsetFields(comm) {
            return {
                offset_hours: comm.offset ? (comm.offset - (comm.offset % ( 60 * 60 ))) / (60*60) : 0,
                offset_minutes: comm.offset ? (comm.offset % ( 60 * 60 )) / 60 : 0,
            }
        },

        getLocalTimeFields(comm) {
            if ( comm.time_in_local_time ) {
                const tilt    = comm.time_in_local_time
                let hours     = (tilt - (tilt % (60*60))) / ( 60 * 60 )
                const minutes = (tilt % (60*60)) / 60
                const A       = hours < 12 ? 'AM' : 'PM'

                hours = hours % 12
                hours = hours == 0 ? 12 : hours

                return { time_in_local_time_formatted: `${hours}:${minutes < 10 ? '0' + minutes : minutes} ${A}` }
            }
            return { time_in_local_time_formatted: null }
        },

        closeCommAnalyticsModal() {
            this.analytics.show = false;
            this.$nextTick(() => {
                this.analytics.iframeUrl = null;
                this.analytics.comm      = null;
            })
        },
        async getCommAnalytics(comm) {
            try {
                const res                = await axios.get(`/api/1/comms/${comm.comm_id}/analytics`);
                this.analytics.comm      = comm;
                this.analytics.iframeUrl = res.data?.iframeUrl;
                this.analytics.show      = true;
            } catch (e) {
            }
        },

        deleteComm(comm) {
            this.deleteCommState.comm    = comm;
            this.deleteCommState.confirm = async () => {
                this.deleteCommState.loading = true;
                try {
                    const res = await axios.delete(`/api/1/comms/${comm.comm_id}`);
                    this.toast.success(`Success, comm ${comm.name} deleted.`)
                    this.campaign.comms = this.campaign.comms.filter(c => c.comm_id != comm.comm_id)
                } catch (e) {
                    console.log(e);
                    this.toast.error(`Error deleting comm ${comm.name}.`)
                }
                this.deleteCommState.loading = false;
                this.deleteCommState.show    = false;
            }
            this.deleteCommState.cancel = () => {
                this.deleteCommState.confirm = null;
                this.deleteCommState.show    = false;
                this.deleteCommState.loading = false;
            }
            this.deleteCommState.show = true;
        }
    },
    computed: {
        previewWidth() {
            switch (this.previewSize) {
                case 'mobile':
                    return '67%'
                case 'tablet':
                    return '90%'
                case 'desktop':
                    return '100%'
            }
        },

        commDetailsMessages() {
            if ( this.showCommDetailsObj.comm_type === 'email' ) {
                return this.showCommDetailsObj.content.emails;
            } else if ( this.showCommDetailsObj.comm_type === 'in-app' ) {
                return this.showCommDetailsObj.content.message;
            }
        },
        // Computed
        history() {
            if ( !this.campaign.history ) return [];
            return this.campaign.history
                .filter(a => a.new_updated_on)
                .sort((a, b) => new Date(b.new_updated_on).getTime() - new Date(a.new_updated_on).getTime())
                .slice(0, this.showAllHistory ? this.campaign.history.length : 2)
        },

    },

    setup() {
        return { toast: useToast() }
    },
    created() {
        this.getCampaign();
    }
}
</script>
